import { TIER_1_ICONS } from '../constants/verticals';
import { api } from './api';
import { captureError } from './monitoring';

export const getTier1Verticals = async () =>
  api
    .get('/verticals/tier1')
    .then(({ data }) => data)
    .catch(() => {});

export const getTier2Verticals = async tier1 =>
  api
    .get(`/verticals/tier2/${tier1}`)
    .then(({ data }) => data)
    .catch(() => {});

export const getTier2Vertical = async tier2 =>
  api
    .get(`/verticals/tier2-vertical/${tier2}`)
    .then(({ data }) => data)
    .catch(() => {});

export const getAllTier2Verticals = async () => {
  try {
    const { data } = await api.get(`/verticals/tier2-all`);
    return data;
  } catch (error) {
    captureError(error);
    return { error };
  }
};

export const formatVerticalsAsOptions = verticals =>
  verticals.map(({ name, sysName }) => ({
    label: name,
    value: sysName,
    icon: TIER_1_ICONS[sysName] || null,
  }));
